import Vue from "vue";
export default {
  props: {
    rowIndex: {
      type: Number,
      required: true
    },
    row: {
      type: Object,
      required: true
    },
    rowActions: {
      type: Array,
      required: true
    },
    locked: Boolean
  },
  data() {
    return {
      open: false
    };
  },
  watch: {
    open(val) {
      this.$emit(val ? "show" : "hide");
    }
  },
  mounted() {
    $(this.$el).on("hide.bs.dropdown", () => {
      this.setOpen(false);
    });
    $(this.$el).on("show.bs.dropdown", () => {
      this.setOpen(true);
    });
  },
  methods: {
    setOpen(val) {
      Vue.set(this, "open", val);
    }
  }
};